export default __webpack_public_path__ + "static/media/045.99ee5494.png";